export default function superset(values, other) {
    var _a;
    var iterator = values[Symbol.iterator](), set = new Set();
    for (var _i = 0, other_1 = other; _i < other_1.length; _i++) {
        var o = other_1[_i];
        var io = intern(o);
        if (set.has(io))
            continue;
        var value = void 0, done = void 0;
        while ((_a = iterator.next(), value = _a.value, done = _a.done, _a)) {
            if (done)
                return false;
            var ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue))
                break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}
